import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';

interface SessionTimeoutWarningProps {
  open: boolean;
  timeRemaining: number | null;
  onExtend: () => void;
  onLogout: () => void;
}

function formatTimeRemaining(ms: number | null): string {
  if (ms === null || ms <= 0) return '0:00';
  
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function SessionTimeoutWarning({
  open,
  timeRemaining,
  onExtend,
  onLogout,
}: SessionTimeoutWarningProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent 
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-warning/10">
            <Clock className="h-6 w-6 text-warning" />
          </div>
          <DialogTitle>Session Expiring Soon</DialogTitle>
          <DialogDescription className="text-center">
            Your session will expire in{' '}
            <span className="font-semibold text-foreground">
              {formatTimeRemaining(timeRemaining)}
            </span>{' '}
            due to inactivity. Click below to stay logged in.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-center">
          <Button onClick={onExtend} className="w-full sm:w-auto">
            Stay Logged In
          </Button>
          <Button 
            variant="outline" 
            onClick={onLogout}
            className="w-full sm:w-auto"
          >
            Log Out
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
